import { SET_SYSTEM_SPECIFIC_FEATURES } from './publicConfigs.actions';
import { LocationAndJobFilterType } from '../../Enums';

const systemSpecificFeaturesInitialState = {
    isGlobalSetupEmployeeDisplayPreferenceAvailable: false,
    isWorkplanIntegrationAvailable: false,
    isNotificationManagerPageExist: false,
    isDataSetManagerPageExist: false,
    isScheduleOverrideAvailable: false,
    isRebidAvailable: false,
    isEmployeeSelectionDateRangeRequired: false,
    isUseUkgReadyTerminology: false,
    isUseCostCenterAsOrgJobPath: false,
    employeeFilters: {
        locationAndJobFilterType: LocationAndJobFilterType.LocationsAndJobs,
    },
};
/**
 * @param {ApiPublicConfigs.ISystemSpecificFeatures} state
 * @param {ShiftBidding.IAction} action
 * */
// eslint-disable-next-line default-param-last
const globalSetupAppDataReducer = (state = systemSpecificFeaturesInitialState, { type, payload }) => {
    switch (type) {
        case SET_SYSTEM_SPECIFIC_FEATURES:
            return {
                ...state,
                ...payload,
                // Deep merge employeeFilters to preserve defaults
                employeeFilters: {
                    ...state.employeeFilters,
                    ...(payload.employeeFilters || {}),
                },
            };
        default:
            return state;
    }
};

export default globalSetupAppDataReducer;
